// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Skeleton,
// } from "@mui/material";
// import { WaterDrop, ChevronRight as ChevronRightIcon, ArrowUpward, ArrowDownward } from "@mui/icons-material";
// import { useAuth } from "../context/AuthContext";
// import axios from "axios";

// const WaterSavedCard = ({ siteId }) => {
//   const { accessToken } = useAuth();
//   const [waterData, setWaterData] = useState({
//     totalSaved: null,
//     changeFromLastMonth: null,
//     trend: null,
//     loading: true,
//     error: null,
//   });

//   const baseURL = process.env.REACT_APP_BASEURL;

//   useEffect(() => {
//     const fetchWaterData = async () => {
//       setWaterData((prev) => ({ ...prev, loading: true, error: null }));
//       try {
//         // Fetch devices, filtered by siteId if provided
//         const devicesParams = siteId !== "all" ? { site: siteId } : {};
//         const devicesRes = await axios.get(`${baseURL}/devices`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//           params: devicesParams,
//         });
//         const deviceIds = devicesRes.data.map((d) => d.id).join(",");

//         // Dynamic dates
//         const now = new Date();
//         const currentStart = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 24 hours ago
//         const lastMonthStart = new Date(now.getTime() - 60 * 24 * 60 * 60 * 1000); // 60 days ago
//         const lastMonthEnd = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago

//         // Fetch current period data
//         const aggRes = await axios.get(`${baseURL}/measurements/aggregated`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//           params: {
//             device: deviceIds,
//             since: currentStart.toISOString(),
//             until: now.toISOString(),
//             aggregate_all: true,
//             fields: "water_balance",
//           },
//         });

//         // Fetch last month data
//         const lastMonthRes = await axios.get(`${baseURL}/measurements/aggregated`, {
//           headers: { Authorization: `Bearer ${accessToken}` },
//           params: {
//             device: deviceIds,
//             since: lastMonthStart.toISOString(),
//             until: lastMonthEnd.toISOString(),
//             aggregate_all: true,
//             fields: "water_balance",
//           },
//         });

//         const currentMean = aggRes.data[0]?.water_balance?.mean || 0;
//         const lastMonthMean = lastMonthRes.data[0]?.water_balance?.mean || 0;
//         const totalSaved = (currentMean * 1000000).toFixed(0); // Example scaling to liters
//         const changeFromLastMonth = ((lastMonthMean - currentMean) * 1000000).toFixed(0); // Difference in liters
//         const trend = lastMonthMean
//           ? (((lastMonthMean - currentMean) / lastMonthMean) * 100).toFixed(1)
//           : null;

//         setWaterData({
//           totalSaved: totalSaved || "N/A",
//           changeFromLastMonth: changeFromLastMonth
//             ? `${changeFromLastMonth > 0 ? "+" : ""}${changeFromLastMonth} L`
//             : "N/A",
//           trend: trend ? `${trend}%` : "N/A",
//           trendValue: trend ? parseFloat(trend) : null,
//           loading: false,
//         });
//       } catch (error) {
//         setWaterData((prev) => ({
//           ...prev,
//           loading: false,
//           error: "Failed to load water data. Please try again.",
//         }));
//       }
//     };
//     if (accessToken && siteId) {
//       fetchWaterData();
//     }
//   }, [accessToken, baseURL, siteId]);

//   const { totalSaved, changeFromLastMonth, trend, trendValue, loading, error } = waterData;

//   if (loading)
//     return (
//       <Card
//         sx={{
//           width: "100%",
//           height: "100%",
//           borderRadius: 15,
//           border: "2px solid black",
//           bgcolor: "#0D9DAA",
//           color: "white",
//           boxShadow: 3,
//         }}
//       >
//         <CardContent>
//           {/* Header */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 1,
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Skeleton
//                 variant="circular"
//                 width={40}
//                 height={40}
//                 sx={{ bgcolor: "rgba(255, 255, 255, 0.2)", mr: 1.5 }}
//               />
//               <Skeleton
//                 variant="text"
//                 width={150}
//                 height={40}
//                 sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
//               />
//             </Box>
//             <Skeleton
//               variant="rectangular"
//               width={80}
//               height={32}
//               sx={{ borderRadius: 10, bgcolor: "rgba(0, 0, 0, 0.9)" }}
//             />
//           </Box>

//           {/* Main Value */}
//           <Skeleton
//             variant="text"
//             width={120}
//             height={48}
//             sx={{ my: 1, bgcolor: "rgba(255, 255, 255, 0.1)" }}
//           />

//           {/* Footer */}
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mt: 1,
//             }}
//           >
//             <Skeleton
//               variant="text"
//               width={150}
//               height={20}
//               sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
//             />
//             <Skeleton
//               variant="text"
//               width={60}
//               height={20}
//               sx={{ bgcolor: "rgba(255, 255, 255, 0.1)" }}
//             />
//           </Box>
//         </CardContent>
//       </Card>
//     );

//   if (error) return <Typography color="error">{error}</Typography>;

//   return (
//     <Card
//       sx={{
//         width: "100%",
//         height: "100%",
//         borderRadius: 15,
//         border: "2px solid black",
//         bgcolor: "#0D9DAA",
//         color: "white",
//         boxShadow: 3,
//       }}
//     >
//       <CardContent>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mb: 1,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", mr: "4rem" }}>
//             <Box
//               sx={{
//                 bgcolor: "rgba(255, 255, 255, 0.2)",
//                 borderRadius: "50%",
//                 p: 1,
//                 mr: 1.5,
//                 display: "flex",
//               }}
//             >
//               <WaterDrop sx={{ fontSize: 24 }} />
//             </Box>
//             <Typography variant="h4" component="div" fontWeight="bold" sx={{ lineHeight: "1" }}>
//               Water <br />Saved
//             </Typography>
//           </Box>
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               bgcolor: "black",
//               borderRadius: 10,
//               border: "2px solid white",
//               px: 1.5,
//               py: 0.5,
//               ml: 1.2,
//             }}
//           >
//             {trendValue !== null && (
//               trendValue > 0 ? (
//                 <ArrowUpward sx={{ fontSize: 16, mr: 0.5, color: "green" }} />
//               ) : trendValue < 0 ? (
//                 <ArrowDownward sx={{ fontSize: 16, mr: 0.5, color: "red" }} />
//               ) : null
//             )}
//             <Typography
//               variant="body2"
//               sx={{
//                 fontWeight: 500,
//                 color: trendValue !== null
//                   ? (trendValue > 0 ? "green" : trendValue < 0 ? "red" : "white")
//                   : "white",
//               }}
//             >
//               {trend || "N/A"}
//             </Typography>
//           </Box>
//         </Box>

//         <Typography
//           variant="h3"
//           component="div"
//           sx={{ fontWeight: 700, my: 2 }}
//         >
//           {totalSaved}
//         </Typography>

//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mt: 1,
//           }}
//         >
//           <Typography variant="body2" sx={{ opacity: 0.9 }}>
//             <Box component="span" sx={{ fontWeight: 500, mr: 1 }}>
//               {changeFromLastMonth || "N/A"}
//             </Box>
//             From last month
//           </Typography>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <Typography variant="body2" sx={{ mr: 0.5 }}>
//               More
//             </Typography>
//             <ChevronRightIcon fontSize="small" />
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default WaterSavedCard;

// New Water Balance code fetch from the Database
import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Skeleton,
} from "@mui/material";
import {
  WaterDrop,
  ChevronRight as ChevronRightIcon,
  ArrowUpward,
  ArrowDownward,
} from "@mui/icons-material";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

const WaterSavedCard = ({ siteId, userSites }) => {
  const { accessToken, isAdmin, isSuperUser } = useAuth();
  const [waterData, setWaterData] = useState({
    totalSaved: null,
    changeFromLastMonth: null,
    trend: null,
    message: null,
    loading: true,
    error: null,
  });

  const baseURL = process.env.REACT_APP_BASEURL;

  const toNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  useEffect(() => {
    const fetchWaterData = async () => {
      if (!accessToken || !siteId || !userSites?.length) return;

      setWaterData((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const res = await axios.get(`${baseURL}/water-balance`, {
          headers: { Authorization: `Bearer ${accessToken}`},
          params: {
            site_id: siteId,
            user_sites: userSites?.join(",")
          },
        });

        const records = res.data.data || [];
        const totalSites = siteId === "all" ? userSites.length : 1;
        const sitesWithData = records.length;
        const allSitesHaveData = sitesWithData === totalSites;
        const someSitesHaveData = sitesWithData > 0 && sitesWithData < totalSites;
        const noSitesHaveData = sitesWithData === 0;
        const isAdminUser = isAdmin || isSuperUser;

        // if (records.length === 0) {
        //   setWaterData({
        //     totalSaved: "N/A",
        //     changeFromLastMonth: "N/A",
        //     trend: "N/A",
        //     trendValue: null,
        //     loading: false,
        //     error: null,
        //   });
        //   return;
        // }

// Case 0: No data at all
if (noSitesHaveData) {
  if (isAdminUser) {
    setWaterData({
      totalSaved: "N/A",
      changeFromLastMonth: "N/A",
      trend: "N/A",
      trendValue: null,
      loading: false,
      error: null,
      message: "Please add data for your sites.",
    });
  } else {
    setWaterData({
      totalSaved: "N/A",
      changeFromLastMonth: "N/A",
      trend: "N/A",
      trendValue: null,
      loading: false,
      message: "Water Balance data is not available.",
      error: null,
    });
  }
  return;
}

// Case 1: Some sites have data, but not all
if (someSitesHaveData) {
  if (isAdminUser) {
    setWaterData({
      totalSaved: "N/A",
      changeFromLastMonth: "N/A",
      trend: "N/A",
      trendValue: null,
      loading: false,
      message: "Add data for remaining sites.",
    });
  } else {
    setWaterData({
      totalSaved: "N/A",
      changeFromLastMonth: "N/A",
      trend: "N/A",
      trendValue: null,
      loading: false,
      message: "Water Balance data is unavailable for some sites."
    });
  }
  return;
}

// Case 2: All sites have data → Normal Flow
  if (allSitesHaveData) {

  if (siteId !== "all") {
    const rec = records[0];
    const trendValue = toNumber(rec.trend);
    setWaterData({
      totalSaved: `${rec.water_balance} ${rec.unit || "L"}`,
      changeFromLastMonth: `${rec.changeFromLastMonth || 0} ${rec.unit || "L"}`,
      trend: `${trendValue}%`,
      trendValue,
      loading: false,
      message: null,
    });
    return;
  }

  // Aggregated view
  const count = records.length;
  const avgSaved = records.reduce((a, r) => a + (r.water_balance || 0), 0) / count;
  const avgChange = records.reduce((a, r) => a + (r.changeFromLastMonth || 0), 0) / count;
  const avgTrend = records.reduce((a, r) => a + toNumber(r.trend), 0) / count;

  setWaterData({
    totalSaved: `${avgSaved.toFixed(0)} L`,
    changeFromLastMonth: `${avgChange.toFixed(0)} L`,
    trend: `${avgTrend.toFixed(1)}%`,
    trendValue: avgTrend,
    loading: false,
    message: null,
  });

  return;
}


        // Case 1: Specific site
        if (siteId !== "all") {
          const rec = records[0];
          const trendValue = toNumber(rec.trend);
          setWaterData({
            totalSaved: `${rec.water_balance} ${rec.unit || "L"}`,
            changeFromLastMonth: `${rec.changeFromLastMonth || 0} ${rec.unit || "L"}`,
            trend: `${trendValue}%`,
            trendValue,
            loading: false,
          })
          return;
        }

        // Case 2: All Sites 
        const count = records.length;
        const avgSaved = records.reduce((a, r) => a + (r.water_balance || 0), 0) / count;
        const avgChange = records.reduce((a, r) => a + (r.changeFromLastMonth || 0), 0) / count;
        const avgTrend = records.reduce((a, r) => a + toNumber(r.trend), 0) / count;

        setWaterData({
          totalSaved: `${avgSaved.toFixed(0)} L`,
          changeFromLastMonth: `${avgChange.toFixed(0)} L`,
          trend: `${avgTrend.toFixed(1)}%`,
          trendValue: avgTrend,
          loading: false,
        });

      } catch (error) {
        console.error("Failed to fetch water data:", error);
        setWaterData((prev) => ({
          ...prev,
          loading: false,
          error: "Failed to load water data. Please try again,",
        }));
      }
    };

    fetchWaterData();
  }, [accessToken, baseURL, siteId, userSites]);

  const { totalSaved, changeFromLastMonth, trend, trendValue, loading, error } = waterData;

 if (loading)
    return (
      <Card
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: 15,
          border: "2px solid black",
          bgcolor: "#0D9DAA",
          color: "white",
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Skeleton variant="circular" width={40} height={40} sx={{ bgcolor: "rgba(255,255,255,0.2)", mr: 1.5 }} />
              <Skeleton variant="text" width={150} height={40} sx={{ bgcolor: "rgba(255,255,255,0.1)" }} />
            </Box>
            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 10, bgcolor: "rgba(0,0,0,0.9)" }} />
          </Box>
          <Skeleton variant="text" width={120} height={48} sx={{ my: 1, bgcolor: "rgba(255,255,255,0.1)" }} />
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
            <Skeleton variant="text" width={150} height={20} sx={{ bgcolor: "rgba(255,255,255,0.1)" }} />
            <Skeleton variant="text" width={60} height={20} sx={{ bgcolor: "rgba(255,255,255,0.1)" }} />
          </Box>
        </CardContent>
      </Card>
    );

  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: 15,
        border: "2px solid black",
        bgcolor: "#0D9DAA",
        color: "white",
        boxShadow: 3,
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", mr: "4rem" }}>
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                borderRadius: "50%",
                p: 1,
                mr: 1.5,
                display: "flex",
              }}
            >
              <WaterDrop sx={{ fontSize: 24 }} />
            </Box>
            <Typography variant="h4" component="div" fontWeight="bold" sx={{ lineHeight: "1" }}>
              Water <br />Saved
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              bgcolor: "black",
              borderRadius: 10,
              border: "2px solid white",
              px: 1.5,
              py: 0.5,
              ml: 1.2,
            }}
          >
            {trendValue > 0 ? (
              <ArrowUpward sx={{ fontSize: 16, mr: 0.5, color: "green" }} />
            ) : trendValue < 0 ? (
              <ArrowDownward sx={{ fontSize: 16, mr: 0.5, color: "red" }} />
            ) : null}
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color:
                  trendValue > 0
                    ? "green"
                    : trendValue < 0
                    ? "red"
                    : "white",
              }}
            >
              {trend || "N/A"}
            </Typography>
          </Box>
        </Box>

        <Typography variant="h3" component="div" sx={{ fontWeight: 700, my: 2 }}>
          {totalSaved}
          {waterData.message && (
            <Typography variant="caption" sx={{ color: "yellow", mb: 0, ml: 1 }}>
              ({waterData.message})
            </Typography>
          )}
        </Typography>


        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            <Box component="span" sx={{ fontWeight: 500, mr: 1 }}>
              {changeFromLastMonth || "N/A"}
            </Box>
            From last month
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {/* <Typography variant="body2" sx={{ mr: 0.5 }}>
              More
            </Typography>
            <ChevronRightIcon fontSize="small" /> */}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default WaterSavedCard;
